export function setScrollTop(top) {
    document.documentElement.scrollTop = top;
    window.pageYOffset = top;
    document.body.scrollTop = top;
}

export function getScrollTop() {
    var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
    return scrollTop;
}

export function timeoutPromise(n) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, n);
    });
}
